module.exports = __webpack_public_path__ + "img/greenwich-g-series-rectangle-high-angle.89a54afd.png";